import { KeyValueModel } from "model";
import { EnumMesas } from "model/enums/enum-mesas";

export const MesaStatusMock: KeyValueModel[] = [
    new KeyValueModel(EnumMesas.ATIVO, "Ativa"),
    new KeyValueModel(EnumMesas.INATIVO, "Inativa"),
    new KeyValueModel(EnumMesas.INVALIDO, "Invalido"),
];
